import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Button from "components/atoms/buttons/Button";
import Modal from "components/atoms/modal";
import { SubmitHandler, useForm } from "react-hook-form";
import InputFieldWithLabel from "components/molecules/forms/InputFieldWithLabel";
import { CloseIcon } from "components/atoms/Icon";

interface IProps {
  open: boolean;
  onClose: () => void;
  handleSubmitClick: SubmitHandler<Inputs>;
}

type Inputs = {
  email: string;
};

const inputSchema = yup.object().shape({
  email: yup.string().email("Not a valid email.").required("Please enter your email."),
});

function NotifyMeEmailInputModal({ open = false, onClose, handleSubmitClick }: IProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({ resolver: yupResolver(inputSchema) });

  return (
    <Modal open={open} onClose={onClose}>
      <div className="relative rounded-2xl bg-primary pb-6 pl-7 pr-7  pt-6 text-white shadow-modal md:w-[600px]">
        <div className="flex justify-between">
          <div className="w-[95%]">
            <h1 className="font-satoshi text-2xl font-bold">Get Notifications</h1>
          </div>

          <span role="button" tabIndex={0} onKeyDown={() => {}} onClick={onClose} className="cursor-pointer">
            <CloseIcon className="h-5 w-5 text-white" />
          </span>
        </div>
        <section className="my-5 w-full font-satoshi text-lg font-450 leading-tight text-white text-opacity-90">
          Enter the email where you would like to receive brand notifications
        </section>
        <form onSubmit={(e) => e.preventDefault()}>
          <InputFieldWithLabel
            register={register}
            errorMessage={errors.email?.message}
            label=""
            id="email"
            placeHolder="Enter email to receive notification regarding this Brand"
          />
          <div className="mt-10 flex justify-end gap-3">
            <Button
              variant="whiteOutline"
              text="CANCEL"
              onClick={onClose}
              additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
            />
            <Button
              variant="magnetiqSolid"
              text="SUBMIT"
              onClick={handleSubmit(handleSubmitClick)}
              additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
            />
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default NotifyMeEmailInputModal;
